import React, { memo, useMemo, useRef } from 'react';
import styled from 'styled-components';
import { TruckCard } from './truckCard/truckCard';
import { PlannerViewTeamCard } from './plannerViewTeamCard';
import styles from './plannerView.module.scss';
import { useBoardStore } from '../boardStore';
import { compareBoardTrucks } from '../truckStatus';
import { truckStatusColumnEnabledFromCompany } from '../../supplementary_components/companySettings';

//${props => props.$teamsectionwidth ? props.$teamsectionwidth : '2rem'};
const TeamContainer = styled.div`
    display:flex;
    width: 100%;
    min-width: 0;
    box-shadow:var(--bottom);
    position: relative; /* For absolute positioning of teamNameSection */
    
    .teamNameSection{
        width: 1.75rem;
        transform: rotate(180deg);
        writing-mode: vertical-rl;
        color:var(--lighter-gray);
        text-align:center;
        font-size:0.9rem;
        position: absolute; /* Remove from normal flow */
        left: 0;
        top: 0;
        bottom: 0; /* Stretch to container height */
        overflow: hidden; /* Crop if content is taller */
        z-index: 1;
    }
    
    &>div{
        &.trucksContainer{
            position: relative;
            background-color: var(--bg);
            /* Planner: fixed to truck column width (set inline). Regular: fills row. */
            flex: 1;
            margin-left: 1.75rem; /* Match teamNameSection width */
            /* This will determine the container height */
        }
        &>div:not(:last-child){
            &>.trckCrd:first-child{
                box-shadow: var(--bottom);
            }
        }
        &>div>div{
            &.highlight{
                background-color: rgba(var(--light-gray-GRB), 0.15);
                .addLoadOrTaskButton{
                    opacity: 0.4;
                }
            }
        }
        
    }
`   

// function updateLoadBasedOnShareData(shareData, load){

//     if(shareData.lastExecutor){
//         if(load){
//             load.startPercentage = 1 - shareData.startPercentage;
//         }
//     }else if(shareData.firstExecutor){
//         if(!load){
//             load = shareData.loadData;
//         }
//         load.endPercentage = shareData.endPercentage;
//     }
//     return load;

// }
export const TeamCard = memo(({index, mainBoardConf, teamData, trucksSetDataMethodsObject, popupViewManagingObject, plannerMode, currentTime, handleScroll, currentTimeRef, beggingingOfDyMl, overflowContainer, currentCompanyId, mainlySolo}) => {
    const loadListsContainer = useRef(null);
    const trucksById = useBoardStore(s => s.trucksById);

    const visibleTruckIds = useBoardStore(s => s.visibleTruckIds);
    const filterText = useBoardStore(s => s.filterText);
    const statusClock = useBoardStore(s => s.statusClock);
    const plannerColumns = useBoardStore(s => s.plannerColumns);
    const sortByTruckStatus = truckStatusColumnEnabledFromCompany()
        && Array.isArray(plannerColumns)
        && plannerColumns.includes('truckStatus');

    const sortedTruckIds = useMemo(() => {
        if (!teamData?.truckIds) return [];

        const ids = teamData.truckIds.filter(id =>
            !filterText || visibleTruckIds.has(id)
        );
        const live = useBoardStore.getState().getLiveCurrentTime?.();
        const nowMs = live && typeof live.toMillis === 'function' ? live.toMillis() : Date.now();
        ids.sort((a, b) => {
            if (!sortByTruckStatus) {
                const ta = trucksById?.[a]?.lastLoadsLastTimecode ?? 0;
                const tb = trucksById?.[b]?.lastLoadsLastTimecode ?? 0;
                return ta - tb;
            }
            return compareBoardTrucks(trucksById?.[a], trucksById?.[b], nowMs);
        });
        return ids;
    // eslint-disable-next-line
    }, [teamData?.truckIds, trucksById, visibleTruckIds, sortByTruckStatus, statusClock]);

    if (sortedTruckIds.length === 0) return null;

    return <>
    {index > 0 ? <div className={styles.divider}></div> :null}
    <TeamContainer  id="TEAM_CARD"  >
        <span className='teamNameSection'>
            {teamData.teamName}
        </span>
        <div
            className="trucksContainer"
            style={
                !plannerMode
                    ? { width: "100%" }
                    : {
                        flex: '0 0 auto',
                        width: mainBoardConf.sectionWidthRem != null
                            ? `${mainBoardConf.sectionWidthRem}rem`
                            : '50rem',
                        marginLeft: '1.75rem',
                        borderRight: "solid thin var(--lighter-gray)",
                        zIndex: 2
                    }
            }
        >
            {sortedTruckIds.map((truckId, index)=>{
                return <TruckCard key={truckId || index} mainBoardConf={mainBoardConf} truckId={truckId}  trucksSetDataMethodsObject={trucksSetDataMethodsObject} popupViewManagingObject={popupViewManagingObject} plannerMode={plannerMode} currentCompanyId={currentCompanyId} mainlySolo={mainlySolo} />
            })}
        </div>
        {!plannerMode || 
             
            <PlannerViewTeamCard
                teamIndex={index}
                loadListsContainer={loadListsContainer}
                trucksSetDataMethodsObject={trucksSetDataMethodsObject}
                teamData={teamData}
                truckIds={sortedTruckIds}
                currentTime={currentTime}
                popupViewManagingObject={popupViewManagingObject}
                overflowContainer={overflowContainer}
                currentTimeRef={currentTimeRef}
                handleScroll={handleScroll}
                beggingingOfDyMl={beggingingOfDyMl}
            />
        
        }
    </TeamContainer>
    </>
})